export const getBoolConverter = {
    fromAttribute: (value) => value && value !== 'false',
    toAttribute: (value) => (value ? 'true' : 'false')
};
export const isValidAttribute = (attrs) => (value) => {
    if (value && attrs.includes(value))
        return value;
    return attrs[0];
};
//# sourceMappingURL=index.js.map